export default __webpack_public_path__ + "static/media/placeholder.4e1e694a.svg";